var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Black",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.38,
    height: 12.02,
    viewBox: "0 0 17.38 12.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Youtube",
    d: "M206.9,376.226v-4.8l4.7,2.409Zm10.311-5.633a3.662,3.662,0,0,0-.691-1.7,2.507,2.507,0,0,0-1.741-.724c-2.432-.173-6.08-.173-6.08-.173h-.008s-3.648,0-6.08.173a2.508,2.508,0,0,0-1.742.724,3.659,3.659,0,0,0-.69,1.7,25.42,25.42,0,0,0-.174,2.766v1.3a25.407,25.407,0,0,0,.174,2.766,3.659,3.659,0,0,0,.69,1.7,2.976,2.976,0,0,0,1.917.731c1.39.131,5.909.172,5.909.172s3.652-.005,6.084-.178a2.51,2.51,0,0,0,1.741-.724,3.662,3.662,0,0,0,.691-1.7,25.413,25.413,0,0,0,.174-2.766v-1.3a25.426,25.426,0,0,0-.174-2.766Z",
    transform: "translate(-200 -368)",
    fill: "#f4efe9",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4e99b95b886b425d024d809029fa695d.svg";
export { ForwardRef as ReactComponent };